// Static content scraped from ceaindia.in + curated B2B copy

export const company = {
  name: "Choudhary Electronics Pvt. Ltd.",
  short: "CEA India",
  founded: "2013",
  tagline: "Engineering-grade precision for laboratories, industries & automation.",
  description:
    "Chaudhary Electronics and Automation (CEA) was founded in 2013 to fulfill the ever-growing demand in the areas of Education, Automation and Industries. We are in the business of providing solutions and services in the field of Education, Automation and Industries — and we deliver products with 100% satisfaction.",
  mission:
    "Work as a team to deliver high-quality services, products, and maintain a professional business relationship with our esteemed clients.",
};

export const contact = {
  head_office: {
    name: "Head Office — Patna",
    person: "Rajeev Chaudhary",
    address:
      "Swaroop Bhawan, Ground floor, Ajanta Colony, Near Shakuntala Lane, Kesari Nagar, Patna-800024, Bihar, India",
    emails: ["sales@ceaindia.in", "rajeeve@ceaindia.in", "info@ceaindia.in"],
    phones: ["+91 91559 76355", "+91 70042 10866"],
  },
  branch_office: {
    name: "Branch Office — Pune",
    person: "Sapna Singh",
    address:
      "Plot Number 330, Sector-24, Near Kidzee School, Nigdi Pradhikaran, Pune-411044, Maharashtra, India",
    phones: ["+91 91581 59775"],
  },
};

export const stats = [
  { value: "13+", label: "Years in service", code: "EST.2013" },
  { value: "500+", label: "Institutions served", code: "EDU.IND.AUT" },
  { value: "200+", label: "Product SKUs", code: "CAT.MASTER" },
  { value: "100%", label: "Quality assurance", code: "QA.PASS" },
];

import { catalogue, subcategoriesByCategory } from "./catalogue";

// ----- Categories — products now come from the scraped catalogue -----
const CATEGORY_META = [
  {
    slug: "education",
    code: "C-01",
    title: "Education",
    short: "Trainer kits & academic instruments",
    description:
      "End-to-end laboratory equipment for engineering colleges, polytechnics and universities — communication, microprocessor, VLSI, embedded, and instrumentation trainers.",
    image:
      "https://images.unsplash.com/photo-1650530415027-dc9199f473ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    slug: "industrial",
    code: "C-02",
    title: "Industrial",
    short: "Components, measurement & lab tools",
    description:
      "Discrete electronic components and tools — resistors, capacitors, ICs, transistors, microcontrollers, SMD parts, relays, buzzers, digital meters, multimeters and CRO probes.",
    image:
      "https://images.unsplash.com/photo-1562408590-e32931084e23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    slug: "automation",
    code: "C-03",
    title: "Automation",
    short: "Entrance & industrial automation",
    description:
      "Entrance automation systems and bespoke industrial automation solutions for commercial spaces, campuses and process plants.",
    image:
      "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

// Inject the subcategory list (slug + title) into each category for linking.
export const categories = CATEGORY_META.map((meta) => ({
  ...meta,
  products: subcategoriesByCategory(meta.slug).map((sub) => ({
    slug: sub.slug,
    name: sub.title,
    count: sub.products.length,
  })),
}));

export { catalogue };

export const featured_products = [
  {
    code: "FP-001",
    name: "Function Generator",
    category: "Test & Measurement",
    image: "/products/8afcac_kfg-02a-function-generator-250x250.jpg",
    link: "/products/function-generator",
  },
  {
    code: "FP-002",
    name: "Regulated DC Power Supply",
    category: "Lab Equipment",
    image: "/products/961f26_kps-3202power-supply-250x250.jpg",
    link: "/products/power-supply",
  },
  {
    code: "FP-003",
    name: "8085 Microprocessor Trainer",
    category: "Education",
    image: "/products/6d1f1a_m85-01-8085-microprocessor-trainer-led-ver-250x250.jpg",
    link: "/products/microprocessor-trainers",
  },
  {
    code: "FP-004",
    name: "Universal VLSI Trainer",
    category: "Education",
    image: "/products/8249c2_universal-vlsi-trainer-250x250.jpg",
    link: "/products/vlsi-trainers",
  },
];

export const news = [
  {
    date: "2025-11-14",
    code: "N-014",
    title:
      "CEA India equips three engineering colleges in Bihar with full VLSI labs",
    excerpt:
      "Complete VLSI trainer suites — including FPGA boards, simulation software and instrumentation — delivered and commissioned ahead of schedule.",
  },
  {
    date: "2025-09-02",
    code: "N-013",
    title: "New entrance automation deployment at Nigdi Pradhikaran campus",
    excerpt:
      "End-to-end boom-barrier and RFID access integration completed for the Pune branch's flagship campus project.",
  },
  {
    date: "2025-06-18",
    code: "N-012",
    title: "Expanded SMD components catalogue now available across Bihar",
    excerpt:
      "Over 80 new SMD line items added to our industrial inventory — same-day dispatch from Patna for trade partners.",
  },
];

export const downloads = [
  { code: "DL-01", name: "CEA Master Catalogue 2025", type: "PDF · 4.8 MB" },
  { code: "DL-02", name: "Education Product Brochure", type: "PDF · 2.1 MB" },
  { code: "DL-03", name: "Industrial Components Pricelist", type: "PDF · 1.4 MB" },
  { code: "DL-04", name: "Automation Solutions Overview", type: "PDF · 3.0 MB" },
  { code: "DL-05", name: "Trainer Kits Datasheet Pack", type: "ZIP · 12.6 MB" },
];

export const nav_links = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About", to: "/about" },
  { label: "Enquiry", to: "/enquiry" },
  { label: "Newsroom", to: "/newsroom" },
  { label: "Downloads", to: "/downloads" },
  { label: "Contact", to: "/contact" },
];

export const hero_bg =
  "https://static.prod-images.emergentagent.com/jobs/374626d9-0d7a-47a2-97fa-2a1aae6192fb/images/de09bc7d0dab9020e0d5a568c42f27caf8f53779376f07b259fb99383ae10877.png";
